import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { ConstructionSearchParam } from '@app/cp/shared/models/ConstructionSearchParam';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { GridDataResult, DataStateChangeEvent, SelectionEvent } from '@progress/kendo-angular-grid';
import { GItem } from '@app/cp/shared/models/GItem';
import { process, aggregateBy, CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { MSCLFilterClass } from '../../shared/classes/filters/MSCLFilterClass';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { NotificationSettings } from '@progress/kendo-angular-notification';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { WipReportData } from '@app/cp/shared/models/WipReportData';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

interface ColumnSetting {
    field: string;
    title: string;
    format?: string;
    type: 'text' | 'numeric' | 'boolean' | 'date';
    hidden: boolean;

}

@Component({
    selector: 'cp-wip-report',
    templateUrl: './wip-report.component.html',
    styleUrls: ['./wip-report.component.scss'],
    standalone: false
})
export class WipReportComponent extends BaseGridComponent<WipReportData, null> implements OnInit, OnDestroy {

    public aggregates: any[] = [];
    public aggregateResults;
    public gridView: GridDataResult;
    public pageSize = 50;
    public confirmBtnStyle: string = 'outline';
    public confirmBtnDisabled: boolean = false;
    public confirmBtnLoading: boolean = false;
    customerNameCF: MSCLFilterClass;
    contractAdministratorCF: MSCLFilterClass;
    locationNameCF: MSCLFilterClass;
    pmCF: MSCLFilterClass;
    divisionNameCF: MSCLFilterClass;
    subs_dataRefUpdated: Subscription;

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private qry_rd: DQOIReferenceDataQuery, svc_data: ConstructionService) {

        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
        this.svc_data = svc_data;
        this.skip = 0;
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        });

        this.aggregates = [
            { field: 'contractNumber', aggregate: 'count' },
            { field: 'jobNumber', aggregate: 'count' },
            { field: 'percComplete', aggregate: 'sum'},
            { field: 'contractAmount', aggregate: 'sum' },
            { field: 'totalEstimatedContractCosts', aggregate: 'sum' },
            { field: 'estimatedContractMaterialCosts', aggregate: 'sum' },
            { field: 'estimatedContractLaborCosts', aggregate: 'sum' },
            { field: 'estimatedContractOtherCosts', aggregate: 'sum' },
            { field: 'pMEstimateAdjustments', aggregate: 'sum' },
            { field: 'projectedGrossProfit', aggregate: 'sum' },
            { field: 'totGrossProfitPerc', aggregate: 'sum' },
            { field: 'committedCosts', aggregate: 'sum' },
            { field: 'jobsWCommittedCostsGTEstimatedCostsLTD', aggregate: 'sum' },
            { field: 'bidHrs', aggregate: 'sum' },
            { field: 'actHrs', aggregate: 'sum' },
            { field: 'percLaborhoursTD', aggregate: 'sum' },
            { field: 'contractRevenue', aggregate: 'sum' },
            { field: 'totalCurrentCosts', aggregate: 'sum' },
            { field: 'totalCurrentMaterialCosts', aggregate: 'sum' },
            { field: 'totalCurrentLaborCosts', aggregate: 'sum' },
            { field: 'totalCurrentOtherCosts', aggregate: 'sum' },
            { field: 'currentGrossProfit', aggregate: 'sum' },
            { field: 'billedToDate', aggregate: 'sum' },
            { field: 'billingsInExcessCostsEstEarningsCostEstEarningsExcessBillings', aggregate: 'sum' },
            { field: 'backlog', aggregate: 'sum' },
            { field: 'totalCostsToComplete', aggregate: 'sum' },
            { field: 'totalMaterialCostsToComplete', aggregate: 'sum' },
            { field: 'totalLaborCostsToComplete', aggregate: 'sum' },
            { field: 'totalOtherCostsToComplete', aggregate: 'sum' },
            { field: 'totalAdjustmentsToBeComplete', aggregate: 'sum' },
            { field: 'grossProfit', aggregate: 'sum' },
            { field: 'amountNotYetBilled', aggregate: 'sum' }
        ];
    }

    subs_dataRef: Subscription;
    svc_data: ConstructionService;
    referenceData: DQOIReferenceData;
    contractAdministratorId: any;

    gridDataPrime: any[] = [];
    //customerId: any;
    //jobClassIds: any;
    //dispatchStatusIds: any;
    constractNo: string;
    billingMonthYear: any;
    projectManagerId: any;

    //Filters
    jobPMs: GItem[] = [];
    contractStatuses: GItem[] = [];
    customers: GItem[] = [];
    jobClasses: GItem[] = [];

    JobPMIds: GItem[] = [];
    dispatchStatusIds: GItem[] = [];
    customerIds: GItem[] = [];
    jobClassIds: GItem[] = [];

    filteredData: any[];
    exportFilteredData: any[];

    ColumnHeaders: ColumnSetting[];
    loading: boolean = true;
    private initSubscription: Subscription;
    private getDataSubscription: Subscription;

    ngOnInit() {
        this.loading = true;
        this.pageSize = 45;
        this.getData();
    }
    override ngOnDestroy() {
        super.ngOnDestroy();
        this.unsubscribeAll();
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }

    public gridData2: any;// = process(this.gridData, this.state);

    getData() {
        let param: ConstructionSearchParam = this.getParam();
        this.svc_data.getWipReportInfo(param).subscribe((data: BaseMessageInfo) => {
            if (data.primaryReturn.length > 0) {

                let arr = [];
                for (let i = 0; i < data.primaryReturn.length; i++) {
                    let newObj: WipReportData = new WipReportData(data.primaryReturn[i]);
                    arr.push(newObj);
                }
                //this.gridData = _.cloneDeep(data.primaryReturn);//.slice(0,100));//.slice(0, 5);
                this.gridData = arr;
                this.filteredData = _.cloneDeep(this.gridData);
                this.processGridData();
                this.calculateDerivedValues();
                this.loadEntries();
                //this.gridData2 = process(this.gridData, this.state);

                this.loading = false;
            } else {
                this.handleNetworkError(JSON.stringify(data.messages));
            }

        },
            error => this.handleNetworkError(error));
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        super.dataStateChange(state);
        this.processGridData();
    }

    processGridData() {
        this.exportFilteredData = filterBy(this.filteredData, this.state.filter);
        if (CommonFunctions.hasArrayElementValue(this.exportFilteredData)) {
            this.aggregateResults = aggregateBy(this.exportFilteredData, this.aggregates);
        }

        this.loading = false;
    }

    returnError: boolean = false;

    calculateDerivedValues() {
        this.filteredData.forEach((element, index) => {
            //T & M Profit
            //element.tAndMProfitPerc = element.tAndMProfitPerc;
            //Total Estimated Costs
            element.totEstContCosts = element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments;
            //Project Gross Profit(Loss)
            element.projGrosProfit = element.contractAmount - (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments);
            //Gross Profit %
            element.projGrosProfitPerc = (element.contractAmount - (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments)) / element.contractAmount;
            //Jobs with committed costs > estimated Costs LTD
            element.jobsCommittCostsGTEstCosts = (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments) - element.committedCosts;
            //% of Labor Hours to Date
            element.percLabHrsToDate = element.actHrs / element.bidHrs;
            //Contract Revenue
            element.contRevenue = element.contractAmount * (element.actHrs / (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments));
            //Total Current Costs
            element.totCurCosts = element.totalCurrentMaterialCosts + element.totalCurrentLaborCosts + element.totalCurrentOtherCosts;
            //Current Gross Profit(Loss)
            element.currentGrossProfit = (element.contractAmount * (element.actHrs / (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments))) - (element.totalCurrentMaterialCosts + element.totalCurrentLaborCosts + element.totalCurrentOtherCosts);
            //(Billings in Excess of Costs & Est.Earnings) / Cost & Est Earnings in Excess of Billings
            element.excessBillings = (element.contractAmount * (element.actHrs / (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments))) - (element.billedToDate);
            //Backlog
            element.backlog = element.contractAmount - (element.contractAmount * (element.actHrs / (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments)));
            //Total Costs to Complete
            element.totCostsToComplete = (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments) - (element.totalCurrentMaterialCosts + element.totalCurrentLaborCosts + element.totalCurrentOtherCosts);
            //Total Material Costs to Complete
            element.totMatCostsToComplete = element.estimatedContractMaterialCosts - element.totalCurrentMaterialCosts;
            //Total Labor Costs to Complete
            element.totLabCostsToComplete = element.estimatedContractLaborCosts - element.totalCurrentLaborCosts;
            //Total Other Costs to Complete
            element.totOthCostsToComplete = element.estimatedContractOtherCosts - element.totalCurrentOtherCosts;
            //Total Adjustments to Complete
            element.totAdjCostsToComplete = element.pmEstimateAdjustments;
            //Gross profit(Loss)
            element.grossProfitLoss = (element.contractAmount - (element.contractAmount * (element.actHrs / (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments)))) - ((element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments) - (element.totalCurrentMaterialCosts + element.totalCurrentLaborCosts + element.totalCurrentOtherCosts));
            //Gross Profit %
            element.grossProfPerc = ((element.contractAmount - (element.contractAmount * (element.actHrs / (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments)))) - ((element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments) - (element.totalCurrentMaterialCosts + element.totalCurrentLaborCosts + element.totalCurrentOtherCosts))) / (element.contractAmount - (element.contractAmount * (element.actHrs / (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments))));
            //Amount Not Yet Billed
            element.amtNotYetBilled = (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments) - ((element.contractAmount * (element.actHrs / (element.estimatedContractMaterialCosts + element.estimatedContractLaborCosts + element.estimatedContractOtherCosts + element.pmEstimateAdjustments))) - (element.billedToDate));
        });

    }

    handleNetworkError(error) {
        this.showError();
    }

    showError() {
        this.loading = false;
        this.returnError = true;
    }

    hideError() {
        this.returnError = false;
    }

    clearData() {
        this.gridData = [];
        this.filteredData = [];
        this.loading = true;
    }

    refreshData() {
        this.filteredData = [];
        this.clearData();
        this.getData();
    }

    unsubscribeAll() {
        if (this.getDataSubscription) {
            this.getDataSubscription.unsubscribe();
        }
    }

    getParam(initial: boolean = false): ConstructionSearchParam {
        let param: ConstructionSearchParam = new ConstructionSearchParam();

        if (!initial) {
            param.userId = this.globals.userId;
            param.companyId = this.globals.companyId;
            param.contractAdministratorId = this.contractAdministratorId;
            param.jobClassIds = this.jobClassIds; // CommonFunctions.getArrayFromCommaDelimitedString(this.jobClassIds);
            param.dispatchStatusIds = this.dispatchStatusIds; // CommonFunctions.getArrayFromCommaDelimitedString(this.dispatchStatusIds);
            param.contractNo = this.constractNo;
            if (this.billingMonthYear != null) {
                param.billingMonthYear = this.billingMonthYear;
            } else {
                param.billingMonthYear = new Date();
                param.billingMonthYear.setDate(1);
            }
        }
        return param;
    }

    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }

    private loadEntries(): void {
        this.gridView = {
            data: this.filteredData.slice(this.skip, this.skip + this.pageSize),
            total: this.filteredData.length
        };
    }

    public expandDetail() {
        return true;
    }

    public filter: CompositeFilterDescriptor;
    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }

    public exportGridToExcel(): void {

        this.grid.saveAsExcel();
    }
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.exportFilteredData) this.exportFilteredData = [];
        const result: ExcelExportData = {
            data: process(this.exportFilteredData as any, {}).data,
        };
        return result;
    }
}
